module.exports = __webpack_public_path__ + "catalog/items/bookcase/bookTexture1.jpg";